<template>
  <LayoutGradient :title="pageTitle" icon="fa-file-signature">
    <template v-slot:headerRight>
      <b-btn variant="outline-info" @click="$router.back()">
        <i class="fas fa-arrow-left"/> {{ $t('sideBar.voltar') }}
      </b-btn>
    </template>
    <b-card class="m-3 mt-n10">
      <b-form @submit="onSubmit">
        <b-form-group :label="$t('integrationHelper.form.fields.nome.label')" label-for="input-name">
          <b-form-input id="input-name" v-model="integrationHelperData.name" type="text"/>
        </b-form-group>
        <b-form-group
            :label="$t('integrationHelper.form.fields.classe.label')"
            label-for="input-classe"
            :description="$t('integrationHelper.form.fields.classe.description')"
        >
          <b-form-input id="input-classe" v-model="integrationHelperData.class" type="text"/>
        </b-form-group>

        <b-form-group
            :label="$t('integrationHelper.form.fields.status.label')"
            label-for="input-status"
            :description="$t('integrationHelper.form.fields.status.description')"
        >
          <b-form-checkbox id="input-status" v-model="integrationHelperData.status" size="lg" switch/>
        </b-form-group>
        <b-button type="submit" variant="success">
          <i class="fas fa-save"/> {{ $t('integrationHelper.form.fields.botao_salvar') }}
        </b-button>
      </b-form>
    </b-card>
  </LayoutGradient>
</template>

<script>
import LayoutGradient from "@/templates/LayoutGradient";
import IntegrationHelper from '@/repositories/vns/IntegrationHelperRepository'
import {mapActions, mapGetters} from "vuex";

export default {
  name: "Form",
  components: {
    LayoutGradient
  },
  data() {
    return {
      integration_help_id: null
    }
  },
  computed: {
    ...mapGetters({
      integrationHelperData: 'integrationHelper/current',
      isLoading: 'integrationHelper/isLoading'
    }),
    pageTitle() {
      if (this.integration_help_id) return this.$t('integrationHelper.form.titulo_pagina.editar')
      return this.$t('integrationHelper.form.titulo_pagina.criar')
    }
  },
  methods: {
    ...mapActions([
      'integrationHelper/listOne',
      'integrationHelper/listAll'
    ]),
    async onSubmit(evt) {
      evt.preventDefault()
      if (this.$route.params.id) {
        this.update()
      } else {
        this.create()
      }
    },
    create() {
      IntegrationHelper.post(this.integrationHelperData).then(() => {
        this.$snotify.success(this.$t('integrationHelper.form.create.success'))
        this.$router.push({name: 'vns.integration_helper'})
      }).catch(error => {
        this.$snotify.error(this.$t('integrationHelper.form.create.error'))
        if (error.response.status === 422) {
          IntegrationHelper.displayValidationErrors(error, this.$snotify)
        }
      })
    },
    update() {
      IntegrationHelper.put(this.integration_help_id, this.integrationHelperData).then(() => {
        this.$snotify.success(this.$t('integrationHelper.form.update.success'))
        this.$router.push({name: 'vns.integration_helper'})
      }).catch(error => {
        this.$snotify.error(this.$t('integrationHelper.form.update.error'))
        if (error.response.status === 422) {
          IntegrationHelper.displayValidationErrors(error, this.$snotify)
        }
      })
    }
  },
  async mounted() {
    this['integrationHelper/listAll'](0)
    this.$store.commit('integrationHelper/setCurrent', {status: false})
    if (this.$route.params.id) {
      this.integration_help_id = this.$route.params.id
      await this['integrationHelper/listOne'](this.$route.params.id)
      this.$store.commit('integrationHelper/setCurrent',
          {...this.integrationHelperData, status: !!this.integrationHelperData.status}
      )
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
